function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 3.2002C8.93115 3.2002 3.19995 8.9314 3.19995 16.0002C3.19995 23.069 8.93115 28.8002 16 28.8002C23.0688 28.8002 28.7999 23.069 28.7999 16.0002C28.7999 8.9314 23.0688 3.2002 16 3.2002ZM21.0208 19.5127C21.4378 19.9298 21.4378 20.6039 21.0208 21.021C20.8128 21.229 20.5397 21.3335 20.2666 21.3335C19.9935 21.3335 19.7205 21.229 19.5125 21.021L16 17.5085L12.4874 21.021C12.2794 21.229 12.0064 21.3335 11.7333 21.3335C11.4602 21.3335 11.1872 21.229 10.9792 21.021C10.5621 20.6039 10.5621 19.9298 10.9792 19.5127L14.4917 16.0002L10.9792 12.4877C10.5621 12.0706 10.5621 11.3965 10.9792 10.9794C11.3962 10.5623 12.0704 10.5623 12.4874 10.9794L16 14.4919L19.5125 10.9794C19.9296 10.5623 20.6037 10.5623 21.0208 10.9794C21.4378 11.3965 21.4378 12.0706 21.0208 12.4877L17.5082 16.0002L21.0208 19.5127Z",
  fill: "currentColor"
});

function SvgIconCloseCircleBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircleBtn);
export default __webpack_public_path__ + "static/media/icon-close-circle-btn.cda13542.svg";
export { ForwardRef as ReactComponent };